import { createApp } from 'vue';
import App from './privacy.vue';

createApp(App).mount('#privacy');
